module.exports = __webpack_public_path__ + "images/status-faded-bg.png";